<template>
  <div class='service-list'>

    <!-- <van-tabs class='job_types' type="card" @click='switchType' v-show='jobTypeList.length' :swipe-threshold="0">
      <van-tab title="全部"></van-tab>
      <van-tab v-for="(type, index) in jobTypeList" :key='index' :title="type.name"></van-tab>
    </van-tabs> -->
    <div class="titlebox">
      <h3 class="titlef">供求信息</h3>
      <p @click='toModule("/parkCompleteSet/campusActivities")'>特卖</p>
    </div>
    <van-list v-model="loading" :finished="finished" @load="loadMore">
      <div class="job_list">
        <Job v-for='(job, index) in jobList' :key='index' :job='job'></Job>
      </div>
    </van-list>
    <van-tabbar v-model="active">
      <van-tabbar-item :to="`/index?parkId=${this.currentParkId}`"><div class="divicon"><van-icon size='22px' name="wap-home" />首页</div></van-tabbar-item>
      <van-tabbar-item to="/propertys"><div class="divicon"><van-icon size='22px' name="like-o" />服务</div></van-tabbar-item>
      <van-tabbar-item to="/humanResource/jobList"><div class="divicon"><van-icon size='22px' name="location-o" />附近</div></van-tabbar-item>
      <van-tabbar-item to="/parkCompleteSet/ExclusiveActivities"><div class="divicon"><van-icon size='22px' name="point-gift-o" />活动</div></van-tabbar-item>
      <van-tabbar-item to="/personal"><div class="divicon"><van-icon size='22px' name="contact" />我的</div></van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import Job from './JobItem';
import { mapGetters } from 'vuex';


export default {
  data() {
    return {
      active: 2,
      jobTypeList: [],
      jobList: [],
      categoryId: '',
      // 当前筛选类型
      condition: {
        currPage: 1,
        pageRows: 10,
      },
      total: 0,
      loading: false,
      finished: false,
    };
  },
  methods: {
    loadMore() {
      if (this.jobList.length >= this.total) {
        return;
      }
      this.loading = true;
      this.condition.currPage++;
      this.getJobList();
    },
    getJobTypeListList() {
      this.$http.post(`${this.URL_PREFIX}/app/get/hr/job/category/list`, {
        parkId: this.currentParkId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.jobTypeList = res.resData.pageList ? res.resData.pageList : [];
        }
      });
    },
    getJobList() {
      this.$http.post(`${this.URL_PREFIX}/app/get/hr/job/info/list`, {
        ...this.condition,
        parkId: this.currentParkId,
        categoryId: this.categoryId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.total = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
          const tempArr = res.resData.pageList ? res.resData.pageList : [];
          this.jobList = this.jobList.concat(tempArr);
          this.finished = this.jobList.length >= this.total ? true : false;
        }else{
          this.$toast(res.resDesc);
        }
        this.loading = false;
      });
    },
    toModule(path) {
      this.$router.push({ path: path });
    },
    // 类型筛选
    switchType(key) {
      this.categoryId = key === 0 ? '' : this.jobTypeList[key-1].id;
      this.condition.currPage = 1;
      this.jobList = [];
      this.getJobList();
    },
  },
  components: { Job },
  computed: {
    ...mapGetters(['currentParkId']),
  },
  mounted() {
    this.getJobTypeListList();
    this.getJobList();
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
  .titlebox{
    padding: 0.32rem 0.48rem;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    background: #fff;
    h3{
      margin-right: .3rem;
      // font-size: .5rem;
    }
    p{
      color: #949fa6;
      // font-size: .5rem;
    }
  .titlef{
      // height: .6rem;
      border-left:4px solid #288ff8;
      padding-left: 0.24rem;
      font-weight: 600;
    }
  }
  .divicon{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      i{
        padding-bottom: .1rem;
      }
    }
.service-list{
  .job_types{
    margin-top: .346667rem;
  }
  .job_list{
    // padding-top: .346667rem;
    padding-bottom: 1.2rem;
    // border-top: .013333rem solid rgb(200, 200, 200);
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/humanResource/components/JobList.vue